<template>
<div class="container">
  <section class="top_section" v-if="user">
    <!-- <div class="experience">
      <div class="progress">
        <div class="measures">
          <i></i>
          <i></i>
          <i></i>
          <i></i>
        </div>
        <div class="fulfilled" :style="{'width': progressPerc + '%'}"></div>
      </div>
      <div class="text_info">
        <div class="wd">
          <p class="left" v-if="winW > 1024 && currentLevel.max_point !== -1 && pointsToNewLvl > 0">{{ $t('top_section.points_to_new_lvl') }}: {{ pointsToNewLvl }}</p>
          <p class="left" v-if="winW <= 1024 && currentLevel.max_point !== -1">{{ currentFriendsLevel.title }}</p>
          <p class="left" v-if="currentLevel.max_point === -1 && currentLevel.id != 11">{{ winW > 1024 ? $t('top_section.need_card') : $t('top_section.buy_card') }}</p>
          <p class="middle" v-if="currentLevel.max_point !== -1 && pointsToNewLvl > 0">{{ levelPointsEarned }}/{{ levelPointsCap }}</p>
          <p class="right" v-if="winW > 1024 && nextLevel" @click="openNextLvlRequirements">{{ nextFriendsLevel.title }} <img src="../assets/img/icons/arrow_right.svg" alt="arrow_right"></p>
          <p class="right" v-else @click="openNextLvlRequirements">{{ nextFriendsLevel.num }}й {{ $t('top_section.lev') }} <img src="../assets/img/icons/arrow_right.svg" alt="arrow_right"></p>
        </div>
      </div>
    </div> -->
    <div class="info_nav">
      <div class="inner">
        <div class="user_name_wrap">
          <div class="inner-flex">
            <h1 v-if="user.personal.name || user.personal.surname"><span>{{ user.personal.name }}</span> <span>{{ user.personal.surname }}</span></h1>
            <div class="add_name" v-else @click="showChangeName">Укажите свое имя</div>
            <!-- <p class="user-card-id-top" v-if="getUserCardID !== null" v-clipboard:copy="getUserCardID">
              {{getUserCardID}}<br>
              <span v-clipboard:copy="getUserCardID" v-clipboard:success="onCopy">{{ this.card_copied ? $t("top_section.copied") : $t("top_section.copy") }}</span>
            </p> -->

          </div>
          <!-- <div @click="showCardQr" class="qr_mobile" v-if="qrValue !== null && winW <= 1024">
            <qrcode :value="qrValue" :options="{size: 82}"></qrcode>
          </div> -->
        </div>
        <!-- <div class="kvs">
          <p class="kv" v-if="winW > 1024">
            <span class="key">{{ $t('top_section.level') }}<span class="colon">: </span> </span><span class="val">{{ currentFriendsLevel.num }}</span>
          </p>
          <p class="kv">
            <span class="key">{{ $t('top_section.points') }}<span class="colon">: </span> </span><span class="val points">{{ user.balance.points }} <span class="points_hint">{{ $t('top_section.points_hint') }}</span> </span>
          </p>
          <p class="kv">
            <span class="key">{{ $t('top_section.subscription') }}<span class="colon">: </span> </span><span class="val">{{ subscription }}</span>
          </p>
        </div> -->
        <div class="nav-wrap">
          <ul class="nav wd">
            <li>
              <router-link to="/" class="tickets">
                <svg width="24" height="24" xmlns="http://www.w3.org/2000/svg"><g fill="none" fill-rule="evenodd"><path d="M0 0h24v24H0z"/><path d="M20 6v2.537A4.003 4.003 0 0 0 18 12c0 1.477.805 2.771 2 3.463V18H4v-2.537A4 4 0 0 0 6 12a4 4 0 0 0-2-3.463V6h16zm0-2H4a2 2 0 0 0-2 2v4a2 2 0 1 1 0 4v4a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-4a2 2 0 1 1 0-4V6a2 2 0 0 0-2-2z" fill="#FFF" fill-rule="nonzero"/></g></svg>
                <span>{{ $t("top_section.navigation.tickets_and_bar") }}</span>
              </router-link>
            </li>
            <!-- <li>
              <router-link to="/friends" class="friends">
                <img src="../img/icons/friends.svg">
                <span>M Friends</span>
              </router-link>
            </li> -->
            <li>
              <router-link to="/profile" class="profile">
                <svg width="24" height="24" xmlns="http://www.w3.org/2000/svg"><g fill="none" fill-rule="evenodd"><path d="M0 0h24v24H0z"/><path d="M12 5c-2.75 0-5 2.25-5 5 0 1.516.707 2.863 1.781 3.781A7.005 7.005 0 0 0 5 20h2c0-2.773 2.227-5 5-5s5 2.227 5 5h2c0-2.7-1.531-5.05-3.781-6.219C16.293 12.863 17 11.516 17 10c0-2.75-2.25-5-5-5zm0 2c1.668 0 3 1.332 3 3s-1.332 3-3 3-3-1.332-3-3 1.332-3 3-3z" fill="#FFF" fill-rule="nonzero"/></g></svg>
                <span>{{ $t("top_section.navigation.profile") }}</span>
              </router-link>
            </li>
            <li>
              <a href="https://multiplex.ua/faq#support" id="support" class="support">
                <svg width="24" height="24" xmlns="http://www.w3.org/2000/svg"><g fill="none" fill-rule="evenodd" ><path d="M0 0h24v24H0z"/><path d="M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2zm0 2a8 8 0 1 0 0 16 8 8 0 0 0 0-16zm1 11v2h-2v-2h2zm-1-8c.897 0 1.705.363 2.229.938.523.574.771 1.319.771 2.062 0 1.286-.73 2.18-1.244 2.773-.515.594-.756.892-.756 1.227h-2c0-1.202.759-1.978 1.244-2.537.485-.56.756-.898.756-1.463 0-.296-.1-.551-.25-.717C12.6 9.118 12.406 9 12 9c-.396 0-.588.12-.744.293-.156.174-.256.44-.256.707H9c0-.732.25-1.467.768-2.043C10.286 7.381 11.093 7 12 7z" fill="#FFF" fill-rule="nonzero"/></g></svg>
                <span>{{ $t("top_section.navigation.support") }}</span>
              </a>
            </li>
            <li><div class="divider"></div></li>
          </ul>
        </div>
      </div>
    </div>
  </section>
</div>
</template>
<script>
import Store from '../store'
export default {
  data: function () {
    return {
      showGoMore: false,
      showWhatNext: false,
      card_copied: false
    }
  },
  computed: {
    winW: function () {
      return Store.state.winW
    },
    user: function () {
      return Store.state.user
    },
    dicts: function () {
      return Store.getters.dicts()
    },
    pointsToNewLvl: function () {
      return this.levelPointsCap - this.levelPointsEarned
    },
    currentLevel: function () {
      return this.dicts.levelsById[this.user.balance.loyalty_level] || this.dicts.levelsById[3] // КОСТЫЛЬ до первой покупки.
    },
    currentFriendsLevel: function () {
      return this.friendsLevelsByDictId[this.user.balance.loyalty_level] || this.dicts.levelsById[3] // КОСТЫЛЬ до первой покупки.
    },
    levelPointsCap: function () {
      return this.currentLevel.max_point - this.currentLevel.min_point > 0 ? this.currentLevel.max_point - this.currentLevel.min_point : 1
    },
    levelPointsEarned: function () {
      return this.user.balance.lifetime_points - this.currentLevel.min_point
    },
    nextLevel: function () {
      return this.dicts.levelsById[this.currentLevel.next_level_id]
    },
    nextFriendsLevel: function () {
      return this.friendsLevelsByDictId[this.currentLevel.next_level_id]
    },
    progressPerc: function () {
      // console.log(this.levelPointsEarned, this.levelPointsCap)
      return parseInt(this.levelPointsEarned / this.levelPointsCap * 100)
    },
    lvlClass: function () {
      return {
        'free_start': [3, 4, 5].indexOf(this.currentLevel.id) !== -1,
        'classic': [6, 7, 8].indexOf(this.currentLevel.id) !== -1,
        'premium': [9, 10, 11].indexOf(this.currentLevel.id) !== -1
      }
    },
    subscription: function () {
      if ([3, 4, 5].indexOf(this.currentLevel.id) !== -1) {
        return 'FREE START'
      } else if ([6, 7, 8].indexOf(this.currentLevel.id) !== -1) {
        return 'CLASSIC'
      } else if ([9, 10, 11].indexOf(this.currentLevel.id) !== -1) {
        return 'PREMIUM'
      }
    },
    getUserCardID: function () {
      if (this.user.cards.length > 0) {
        return this.user.cards[0].number
      } else {
        return null
      }
    },
    qrValue: function () {
      if (this.user.cards.length > 0) {
        Store.commit('setCardQr', this.user.cards[0].number)
        return this.user.cards[0].number
      } else {
        return null
      }
    },
    friendsLevelsByDictId: function () {
      return Store.getters.friendsLevelsByDictId()
    }
  },
  methods: {
    showSupport: function () {
      Store.commit('showSupport')
    },
    handleAvatarSuccess: function (res, url) {
      Store.commit('setUserAvatar', res.url)
    },
    showChangeName: function () {
      Store.commit('showChangeName')
    },
    showCardQr: function () {
      Store.commit('showCardQr')
    },
    openNextLvlRequirements: function () {
      Store.commit('openNextLvlRequirements')
    },
    onCopy: function () {
      this.card_copied = true
      setTimeout(() => {
        this.card_copied = false
      }, 3000)
    }
  },
  created: function () {
    // Store.dispatch('getUser')
    var self = this
    document.addEventListener('click', function () {
      self.showGoMore = false
      self.showWhatNext = false
    })
  }
}
</script>



// WEBPACK FOOTER //
// top-section.vue?0ba16cb8